/**
 * Gate for screens that need somebody signed in.
 *
 * This is a courtesy, not a control: the API refuses every one of these calls
 * without a valid token regardless of what the browser lets a person open.
 * What it buys is that a member meets a sign-in form rather than a screen
 * that renders empty and then errors — and that they land where they were
 * going once they are in, rather than back at the home screen.
 */
import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { isSignedIn } from "../lib/api";

export function RequireAuth({ children }: { children: ReactNode }) {
  const location = useLocation();

  if (!isSignedIn()) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/signin?next=${next}`} replace />;
  }
  return <>{children}</>;
}
